export const bgClassesBase = 'bg-white dark:bg-slate-900';
export const bgClasses100 = 'bg-slate-100 dark:bg-slate-800';
export const bgClasses200 = 'bg-slate-200 dark:bg-slate-700';
export const bgClassesTransparent = 'bg-transparent dark:bg-transparent';

export const bgBlueClasses400 = 'bg-blue-400 dark:bg-blue-600';
export const bgBlueClasses500 = 'bg-blue-500 dark:bg-blue-500';
export const bgBlueClasses600 = 'bg-blue-600 dark:bg-blue-400';
export const bgBlueClasses700 = 'bg-blue-700 dark:bg-blue-300';

export const bgNegative200 = 'bg-red-200 dark:bg-red-800';

export const textInvertedClassesBase = 'text-white dark:text-slate-950';

export const textClassesBase = 'text-slate-900 dark:text-slate-100';
export const textClasses300 = 'text-slate-300 dark:text-slate-700';
export const textClasses400 = 'text-slate-400 dark:text-slate-600';
export const textClasses500 = 'text-slate-500 dark:text-slate-500';
export const textClasses600 = 'text-slate-600 dark:text-slate-400';
export const textClasses700 = 'text-slate-700 dark:text-slate-300';

export const primaryClasses500 = 'text-primary-500 dark:text-primary-500';

export const borderClasses100 =
  'border-slate-100 border-2 dark:border-slate-800';
export const borderClasses200 =
  'border-slate-200 border-2 dark:border-slate-700';
export const borderClasses300 =
  'border-slate-300 border-2 dark:border-slate-600';
